<template>
    <FormGroup
        :name="name"
        :label="label"
        :as-row="asRow"
        :size="size"
        :required="required"
        :errors="errors"
        :hide-validation="!showValidation">
        <template #default>
            <MaskedInput
                ref="input"
                v-model="model"
                mask="digits"
                class="form-control"
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
                :class="inputClass"
                :name="name"
                :required="required"
                v-bind="$attrs" />
        </template>

        <template #tips>
            <slot />
        </template>
    </FormGroup>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import FormGroup from '@/js/components/common/fields/FormGroup';
import MaskedInput from '@/js/components/common/inputs/masked-input/MaskedInput';

export default {
    name: 'DigitsField',

    components: {FormGroup, MaskedInput},

    mixins: [FieldMixin],

    inheritAttrs: false,

    props: {
        value: {type: [String, Number], default: null},
    },

    computed: {
        length() {
            return String(this.value || '').length;
        },
    },

    methods: {
        validate(value) {
            const errors = [];

            if (this.required && (value === null)) {
                errors.push(this.$t('validation.custom.required'));
            }

            if (this.$attrs.minlength && (0 < this.length && this.length < Number(this.$attrs.minlength))) {
                errors.push(this.$t('validation.custom.digits', {value: this.$attrs.minlength}));
            }

            this.modelErrors = errors;
        },
    },
};
</script>
